module.exports = __webpack_public_path__ + "img/ntc.4f7379c5.jpg";